import * as yup from 'yup'

import helpers from 'helpers'

const schemaLastUpdate = yup.object().shape({
  title: yup.string().required(),
  subtitle: yup.string().required(),
  tag: yup.string().required(),
  description: yup
    .string()
    .required()
    .test(
      'hasContent',
      'Preencha esse campo',
      helpers.validates.jodit.hasContent,
    ),
})

export default schemaLastUpdate
